import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loadingTasks': false,
  'tasksList': [],
  'loadingProvidersOutsourced': false,
  'providersOutsourcedList': [],
};

export const tasksAssignmentInQualityAssuranceOrders = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_TASKS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingTasks': true,
    }),
    [ActionTypes.FETCHED_TASKS_AVAILABLE]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'tasksList': action.response.data,
    }),
    [ActionTypes.FETCHED_TASKS_AVAILABLE_FAILED]: (state, action) => ({
      ...state,
      'loadingTasks': false,
      'tasksList': [],
    }),
    [ActionTypes.FETCHING_PROVIDERS_OUTSOURCED]: (state, action) => ({
      ...state,
      'loadingProvidersOutsourced': true,
    }),
    [ActionTypes.FETCHED_PROVIDERS_OUTSOURCED]: (state, action) => ({
      ...state,
      'loadingProvidersOutsourced': false,
      'providersOutsourcedList': action.response.data,
    }),
    [ActionTypes.FETCHED_PROVIDERS_OUTSOURCED_FAILED]: (state, action) => ({
      ...state,
      'loadingProvidersOutsourced': false,
      'providersOutsourcedList': [],
    }),
  })(state, action);
};
